const SOURCEFORM_TMBD = 'tmBd'
const TMBD_PADDINGTOP = '15px'
export {
  // eslint-disable-next-line import/prefer-default-export
  SOURCEFORM_TMBD, // 团建小程序
  TMBD_PADDINGTOP, // 距离头部

}
